import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormBody,
  SecondaryButton,
  Button as ButtonTypography
} from '@huggg/react-components';

import Dialog from '../Dialog/Dialog';
import styles from './sendqrcodebutton.module.scss';
import SvgIcon from '../SvgIcon/SvgIcon';

/**
 * Generate a canvas QR code image from the provided code
 *
 * @link https://www.npmjs.com/package/qrcode
 * @param {Object} props
 */
const SendQRCodeButton = props => {
  const { hugggId, onSendQRCodeEmail } = props;

  // Send Email Dialog
  const [showSendEmailDialog, setShowSendEmailDialog] = useState(false);

  return (
    <div>
      <SecondaryButton
        className={styles.button}
        onClick={() => setShowSendEmailDialog(true)}
      >
        <div className={styles.buttonLabel}>
          <SvgIcon name="email" className={styles.buttonIcon} />
          <ButtonTypography>Email me this QR code</ButtonTypography>
        </div>
      </SecondaryButton>
      <Dialog
        title="Send QR Code"
        visible={showSendEmailDialog}
        showCloseButton
        contentClassName={styles.dialogContent}
        onClose={() => setShowSendEmailDialog(false)}
      >
        <FormBody
          className={styles.formBody}
          model={[
            {
              name: 'email',
              elementType: 'string',
              placeholder: 'Email address',
              optional: false
            }
          ]}
          initialValues={{
            email: ''
          }}
          buttonCopy={'Send Email'}
          onConfirm={({ email }) => {
            onSendQRCodeEmail(hugggId, email);
            setShowSendEmailDialog(false);
          }}
        />
      </Dialog>
    </div>
  );
};

SendQRCodeButton.propTypes = {
  hugggId: PropTypes.string,
  onClose: PropTypes.func,
  onSendQRCodeEmail: PropTypes.func,
};

export default SendQRCodeButton;
